import { render, staticRenderFns } from "./InHospitalDetailDispatch.vue?vue&type=template&id=99311a5c"
import script from "./InHospitalDetailDispatch.vue?vue&type=script&lang=js"
export * from "./InHospitalDetailDispatch.vue?vue&type=script&lang=js"
import style0 from "./InHospitalDetailDispatch.vue?vue&type=style&index=0&id=99311a5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports